<template>
    <v-container
        class="tiering"
        :class="'layout-' + layout"
        fluid
        :id="`${baseId}-container`"
    >
        <v-layout class="tiering-content" justify-space-between :id="`${baseId}-container-layout`">
            <!-- Layout: None -->
            <template v-if="layout==='none'"></template>
            <!-- Layout: Joined -->
            <template v-else-if="layout==='joined'">
                <div class="tier-container" :id="`${baseId}-container-joined-tier-container`">
                    <v-card
                        class="tier-summary ma-0 pa-6"
                        :class="[ 'tier-1', 'tier-em-' + highlight ]"
                        :id="`${baseId}-container-joined-tier-card`"
                    >
                        <v-container fluid :id="`${baseId}-container-joined-tier-card-container`">
                            <v-layout row flex-nowrap :id="`${baseId}-container-joined-tier-card-heading-container`">
                                <v-flex class="tier-description" :id="`${baseId}-container-joined-tier-card-heading-title-container`">
                                    <v-card-title class="tier-title ma-0 pa-0 tx-font-primary" :id="`${baseId}-container-joined-tier-card-heading-title-title-card`">
                                        <h1 class="ma-0 pa-0 text text-left" :id="`${baseId}-container-joined-tier-card-heading-title-title-text`">
                                            {{ $nsLanguage.getTranslation('tieringLandingPage.headingTitle') }}
                                        </h1>
                                    </v-card-title>
                                </v-flex>
                                <v-flex
                                    class="tier-info ml-7"
                                    :style="{ width: tierWidth }"
                                    v-for="(tier, index) in tiers"
                                    :key="index"
                                    :id="`${baseId}-container-joined-tier-card-heading-tier-${index}`"
                                >
                                    <v-card-title
                                        class="tier-title justify-center ma-0 pa-0 tx-font-primary"
                                        :id="`${baseId}-container-joined-tier-card-heading-tier-${index}-tier-id-card`"
                                    >
                                        <h1 class="text" :id="`${baseId}-container-joined-tier-card-heading-tier-${index}-tier-id-text`">
                                            {{ $nsLanguage.getTranslation('tieringLandingPage.' + tier.tierId) }}
                                        </h1>
                                    </v-card-title>
                                </v-flex>
                            </v-layout>
                            <v-layout
                                class="justify-center align-content-center align-center" row flex-nowrap mt-8 pa-0
                                :id="`${baseId}-container-joined-tier-card-purchase-ratio-container`"
                            >
                                <v-flex class="tier-description" :id="`${baseId}-container-joined-tier-card-purchase-ratio-heading-container`">
                                    <v-card-text
                                        class="summary-message ma-0 pa-0 tx-font-primary"
                                        :id="`${baseId}-container-joined-tier-card-purchase-ratio-heading-purchase-ratio-card`"
                                    >
                                        <div class="tx-gray-dark" :id="`${baseId}-container-joined-tier-card-purchase-ratio-heading-purchase-ratio-text`"
                                        >{{ $nsLanguage.getTranslation('tieringLandingPage.headingDetail1') }}</div>
                                    </v-card-text>
                                </v-flex>
                                <v-flex
                                    class="tier-info ml-7" :style="{ width: tierWidth }"
                                    v-for="(tier, index) in tiers"
                                    :key="index"
                                    :id="`${baseId}-container-joined-tier-card-purchase-ratio-tier-${index}`"
                                >
                                    <v-card-text
                                        class="summary-number justify-center ma-0 pa-0 tx-font-primary"
                                        :id="`${baseId}-container-joined-tier-card-purchase-ratio-tier-${index}-purchase-ratio-card`"
                                    >
                                        <div class="text-center" :id="`${baseId}-container-joined-tier-card-heading-tier-${index}-purchase-ratio-text`">
                                            {{ tier.purchaseRatio | numeral('0%') }}
                                        </div>
                                    </v-card-text>
                                </v-flex>
                            </v-layout>
                            <template v-if="bullets.length > 0">
                                <v-layout row mt-5 mb-0 pa-0 :id="`${baseId}-container-joined-tier-card-bullet-divider-container`">
                                    <v-divider class="summary-divider hightlight" :id="`${baseId}-container-joined-tier-card-bullet-divider`" />
                                </v-layout>
                                <v-layout
                                    class="tier-row" row justify-center align-content-center align-center flex-nowrap my-0 pa-0 py-4
                                    v-for="(bullet, index) in bullets"
                                    :key="index"
                                    :id="`${baseId}-container-joined-tier-card-bullet-${index}-container`"
                                >
                                    <v-flex class="tier-description" :id="`${baseId}-container-joined-tier-card-bullet-${index}-bullet-container`">
                                        <v-card-text class="ma-0 pa-0" :id="`${baseId}-container-joined-tier-card-bullet-${index}-bullet-card`">
                                            <span class="tx-em-bold-700 tx-gray-dark" v-html="bullet" :id="`${baseId}-container-joined-tier-card-bullet-${index}-bullet-text`">
                                            </span>
                                        </v-card-text>
                                    </v-flex>
                                    <v-flex
                                        class="tier-info ml-7"
                                        :style="{ width: tierWidth }"
                                        v-for="(tier, ti) in tiers"
                                        :key="ti"
                                        :id="`${baseId}-container-joined-tier-card-bullet-${index}-tier-${ti}-container`"
                                    >
                                        <v-card-text
                                            class="tier-bullet-image text-center ma-0 pa-0"
                                            v-if="tier.bullets.indexOf(bullet) >= 0"
                                            :id="`${baseId}-container-joined-tier-card-bullet-${index}-tier-${ti}-card`"
                                        >
                                            <img
                                                class="icon"
                                                src="@/assets/icons/Icon_Checkmark_Active.svg"
                                                :id="`${baseId}-container-joined-tier-card-bullet-${index}-tier-${ti}-active-checkmark`"
                                            />
                                        </v-card-text>
                                    </v-flex>
                                </v-layout>
                            </template>
                            <template v-if="showLocked">
                                <v-layout row flex-nowrap mt-5 pa-0 :id="`${baseId}-container-joined-tier-card-show-locked-container`">
                                    <v-flex class="tier-description" :id="`${baseId}-container-joined-tier-card-show-locked-heading-detail-flex`">
                                        <v-card-text class="ma-0 pa-0" :id="`${baseId}-container-joined-tier-card-show-locked-heading-deatail-container`">
                                            <span class="text-uppercase tx-bold-800 tx-gray-dark" :id="`${baseId}-container-joined-tier-card-show-locked-heading-detail-text`">
                                                {{ $nsLanguage.getTranslation('tieringLandingPage.headingDetailUnlock') }}
                                            </span>
                                        </v-card-text>
                                    </v-flex>
                                    <v-flex
                                        class="tier-info ml-7"
                                        :style="{ width: tierWidth }"
                                        v-for="(tier, index) in tiers"
                                        :key="index"
                                        :id="`${baseId}-container-joined-tier-card-show-locked-container-tier-${index}-container`"
                                    >
                                        <!-- Template: Common -->
                                        <template v-if="tier.template === 'common' && tier.unlockText && showTierUnlockContent(tier)">
                                            <p
                                                class="summary-instruction text-center tx-font-primary tx-em-bold-700 tx-gray-light"
                                                v-if="tier.unlockLink"
                                                :id="`${baseId}-container-joined-tier-card-show-locked-container-tier-${index}-unlock-link-container`"
                                            >
                                                <a
                                                    class="summary-link tx-font-primary"
                                                    :href="mapLink(tier.unlockLink)"
                                                    v-html="$nsLanguage.getTranslation('tieringLandingPage.' + tier.unlockText, tier)"
                                                    @click="publishEvent($event, tier)"
                                                    :id="`${baseId}-container-joined-tier-card-show-locked-container-tier-${index}-unlock-link`"
                                                >
                                                </a>
                                            </p>
                                            <p
                                                class="summary-instruction text-center tx-font-primary tx-em-bold-700 tx-gray-light"
                                                v-else
                                                v-html="$nsLanguage.getTranslation('tieringLandingPage.' + tier.unlockText, tier)"
                                                :id="`${baseId}-container-joined-tier-card-show-locked-container-tier-${index}-unlock-text`"
                                            >
                                            </p>
                                        </template>
                                    </v-flex>
                                </v-layout>
                            </template>
                        </v-container>
                    </v-card>
                </div>
            </template>
            <!-- Layout: Other -->
            <template v-else>
                <template v-for="(tier, index) in tiers">
                    <div class="tier-container" :key="index" :id="`${baseId}-container-other-tier-card-tier-${index}-container`">
                        <v-card
                            class="tier-summary pa-6"
                            :class="[ 'tier-' + (index + 1), 'tier-em-' + highlight, { 'tier-unlockable': showTierUnlockContent(tier) } ]"
                            :id="`${baseId}-container-other-tier-card-tier-${index}-card`"
                        >
                            <v-card-title
                                class="tier-title justify-center z-index-high ma-0 pa-0 tx-font-primary"
                                :id="`${baseId}-container-other-tier-card-tier-${index}-card-title-container`"
                            >
                                <h1 class="ma-0 pa-0 text" :id="`${baseId}-container-other-tier-card-tier-${index}-card-title-text`"
                                >{{ $nsLanguage.getTranslation('tieringLandingPage.' + tier.tierId) }}
                                    <span v-if="showLocked && locked" :id="`${baseId}-container-other-tier-card-tier-${index}-card-title-text-locked`">
                                         - {{ $nsLanguage.getTranslation('tieringLandingPage.locked') }}
                                    </span>
                                </h1>
                            </v-card-title>
                            <v-card-text
                                class="summary-number justify-center z-index-high ma-0 mt-4 pa-0 tx-font-primary"
                                :id="`${baseId}-container-other-tier-card-tier-${index}-purchase-ratio-card`"
                            >
                                <div class="text-center" :id="`${baseId}-container-other-tier-card-tier-${index}-purchase-ratio-text`"
                                >{{ tier.purchaseRatio | numeral('0%') }}</div>
                            </v-card-text>
                            <v-card-text
                                class="summary-message justify-center z-index-high mt-1 pa-0 tx-font-primary"
                                :id="`${baseId}-container-other-tier-card-tier-${index}-heading-text-card`"
                            >
                                <div
                                    class="text-center tx-em-bold-700 tx-gray-dark"
                                    v-html="$nsLanguage.getTranslation('tieringLandingPage.headingText', { currency_amount: currency(tier.minSpend) })"
                                    :id="`${baseId}-container-other-tier-card-tier-${index}-heading-text-text`"
                                >
                                </div>
                            </v-card-text>
                            <template v-if="tier.bullets && tier.bullets.length > 0">
                                <v-divider class="summary-divider z-index-high hightlight mt-5" :id="`${baseId}-container-other-tier-card-tier-${index}-bullets-divider`"/>
                                <div class="summary-section z-index-high mt-6 tx-font-primary" :id="`${baseId}-container-other-tier-card-tier-${index}-bullets-container`">
                                    <ul class="summary-bullet-list" :id="`${baseId}-container-other-tier-card-tier-${index}-bullets-list`">
                                        <li class="checkmark" v-for="(bullet, ji) in tier.bullets" :key="ji" :id="`${baseId}-container-other-tier-card-tier-${index}-bullet-${ji}`">
                                            <v-card-text class="ma-0 pa-0" :id="`${baseId}-container-other-tier-card-tier-${index}-bullet-${ji}-card`">
                                                <span
                                                    class="text tx-font-primary tx-em-bold-700 tx-gray-dark"
                                                    v-html="bullet"
                                                    :id="`${baseId}-container-other-tier-card-tier-${index}-bullet-${ji}-text`"
                                                >
                                                </span>
                                            </v-card-text>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                            <template v-if="showTierUnlockContent(tier)">
                                <div
                                    class="summary-section summary-unlock z-index-high tx-font-primary"
                                    :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-content-section`"
                                >
                                    <v-divider class="summary-divider mt-6" :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-content-divider`"/>
                                    <div class="unlock-content mt-7" :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-content-container`">
                                        <h2
                                            class="summary-section-heading text-center tx-gray-dark mb-2 tx-font-primary"
                                            v-if="tier.unlockTitle"
                                            :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-content-title`"
                                        >{{ $nsLanguage.getTranslation('tieringLandingPage.' + tier.unlockTitle, tier) }}</h2>
                                        <!-- Unlock Template: Common -->
                                        <template v-if="tier.template === 'common' && tier.unlockText">
                                            <p
                                                class="summary-instruction text-center tx-font-primary tx-gray-light ma-0"
                                                v-if="tier.unlockLink"
                                                :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-tier-link-container`"
                                            >
                                                <a
                                                    class="summary-link"
                                                    :href="mapLink(tier.unlockLink)"
                                                    v-html="$nsLanguage.getTranslation('tieringLandingPage.' + tier.unlockText, tier)" @click="publishEvent($event, tier)"
                                                    :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-tier-link`"
                                                >
                                                </a>
                                            </p>
                                            <p
                                                class="summary-instruction text-center tx-font-primary tx-gray-light tx-em-bold-700 ma-0"
                                                v-else
                                                v-html="$nsLanguage.getTranslation('tieringLandingPage.' + tier.unlockText, tier)"
                                                :id="`${baseId}-container-other-tier-card-tier-${index}-unlock-tier-text`"
                                            >
                                            </p>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </v-card>
                    </div>
                </template>
            </template>
        </v-layout>
    </v-container>
</template>

<script>

import { formatPoints } from '../../../services/points'

import { events } from '@nuskin/ns-util'

export default {
    name: 'ns-landing-white-tiering-cards',
    props: {
        highlight: {
            type: String,
            default: 'none',
            validator (value) {
                return ['none', 'basic', 'all'].indexOf(value) >= 0
            }
        },
        locked: {
            type: Boolean,
            default: false
        },
        showLocked: {
            type: Boolean,
            default: true
        },
        links: {
            type: Object,
            default: function () {
                return {}
            }
        },
        parentId: {
            type: String,
            required: false
        },
        tiers: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    // data () {
    //   return {
    //   }
    // },
    computed: {
        baseId: function () {
            const defaultBase = 'landing-white-tier-cards'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        },
        bullets () {
            const bullets = this.tiers.reduce((acc, tier) => {
                if (tier.bullets) {
                    tier.bullets.forEach((bullet) => {
                        if (acc.indexOf(bullet) < 0) {
                            acc.push(bullet)
                        }
                    })
                }

                return acc
            }, [])

            return bullets.sort((s1, s2) => s1.localeCompare(s2, undefined, {
                ignorePunctuation: true,
                numeric: true,
                sensitivity: 'base'
            }))
        },
        layout () {
            let layout

            if (this.tiers.length < 1) {
                layout = 'none'
            } else if (this.tiers.length > 0 && this.tiers[0].template === 'custom') {
                layout = 'custom'
            } else if (this.isMobile) {
                layout = 'vertical'
            } else if (this.isTablet) {
                layout = 'joined'
            } else {
                layout = 'horizontal'
            }

            return layout
        },
        tierWidth () {
            if (this.layout === 'horizontal') {
                return Math.floor(100 / this.tiers.length).toFixed(4) + '%'
            } else if (this.layout === 'joined') {
                return Math.floor(50 / this.tiers.length).toFixed(4) + '%'
            }

            return '100%'
        },
        isMobile () {
            return this.$vuetify.breakpoint.smAndDown
        },
        isTablet () {
            return this.$vuetify.breakpoint.md
        }
    },
    methods: {
        currency (value) {
            return formatPoints(value)
        },
        mapLink (link) {
            return this.links[link]
        },
        showTierUnlockContent (tier) {
            if (this.showLocked && tier.unlockable) {
                if ((typeof tier.showUnlockRule) === 'function') {
                    return !!tier.showUnlockRule(tier)
                }

                if (tier.showUnlockRule == null || !!tier.showUnlockRule) {
                    return tier.unlockTitle || (tier.template === 'common' && tier.unlockText)
                }
            }

            return false
        },
        publishEvent ($event, tier) {
            if (tier.event) {
                events.tag(tier.event, { context: 'landing' })
            }
        }
    }
}

</script>

<style lang="scss" scoped>

@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

$color-blue: #02B2DF;
$color-blackhole: map.get(colors.$baseColors, blackhole);
$color-dryink: map.get(colors.$baseColors, dryink);
$color-steel: map.get(colors.$baseColors, steel);
$color-white: #FFFFFF;

.tx-bold-800 {
    font-family: "proxima-nova";
    font-style: normal;
    font-weight: 800;
}

.tx-em-bold-700 {
    ::v-deep {
        b, em, i {
            font-family: inherit;
            font-style: normal;
            font-weight: 700;
        }
    }
}

.z-index-low {
    z-index: 1;
    position: relative;
}

.z-index-high {
    z-index: 10;
    position: relative;
}

.tiering
{
    padding: 0;
    background-color: transparent;

    p {
        margin: 0;
    }

    &.layout-joined {
        .summary-instruction {
            line-height: 1.0833em;
        }

        .tier-row {
            border-bottom: 1px solid #CED0D0;
        }
    }

    &.layout-horizontal {
        .tiering-content {
            flex-direction: row;
        }

        .tier-container {
            margin: 0 12px;
        }

        .tier-summary {
            display: inline-block;
        }

        .tier-unlockable {
            .summary-unlock {
                min-height: 100px;
            }
        }
    }

    &.layout-vertical {
        .tiering-content {
            flex-direction: column;
        }

        .tier-container {
            margin: 15px 0;
        }

        .tier-summary {
            display: block;
        }

        .tier-unlockable {
            .summary-unlock {
                min-height: 100px;
            }
        }
    }
}

.tiering-content {
    display: flex;
    flex-wrap: nowrap;
    padding: 0;
}

.tier-container {
    overflow: hidden;
    width: 100%;
    background-color: $color-white;
    border-radius: 10px;
}

.tier-summary {
    position: relative;
    text-align: initial;
    width: 100%;
    background-color: transparent;
    box-shadow: none;
    font-size: 14px;

    ::v-deep {
        // Vuetify override
        .container {
            margin-right: auto;
            margin-left: auto;
            padding: 12px;
        }

        .v-progress-linear__determinate {
            position: relative;
        }
        // End of Vuetify override
    }

    .summary-bullet-list {
        &,
        & li {
            list-style-type: none;
            list-style-image: none;
            list-style-position: inside;
            margin: 0;
            padding: 0;
        }

        li {
            display: flex;
            align-content: center;
            align-items: center;
            position: relative;
            margin-top: 15px;

            ::v-deep em {
                font-style: normal;
                font-weight: 700;
            }

            .text {
                font-size: 14px;
                font-weight: normal;
                line-height: 1.11;
            }

            &:first-child {
                margin-top: 0;
            }
        }

        li.checkmark {
            min-height: 29px;
            padding-left: 42px;

            &::before {
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                width: 29px;
                height: 29px;
                background-image: url( '~@/assets/icons/Icon_Checkmark_Inactive.svg' );
                background-attachment: local;
                background-origin: padding-box;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;
                content: ' ';
            }
        }
    }

    .summary-divider {
        border-color: $color-steel;
    }

    .summary-instruction {
        font-size: 12px;
        font-weight: normal;
    }

    .summary-message {
        font-size: 14px;
        font-weight: normal;
        line-height: 1.11em !important;
    }

    .summary-number {
        line-height: 1;
        color: rgba( 0,0,0,0.50 );
        font-size: 45px;
        font-weight: 600;
    }

    .summary-link {
        cursor: pointer;
        color: $color-blue;
        font-size: 12px;
        font-weight: normal;
        text-decoration: underline;
        line-height: 1.0833em;
    }

    .summary-section {
        line-height: 1.22em !important;
        font-weight: normal;
        border-radius: 0;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .summary-section-heading {
        font-size: inherit;
        font-weight: 700;
        line-height: 1.11;
        text-transform: uppercase;
    }

    .summary-unlock {
        position: relative;
    }

    .summary-watermark {
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .unlock-content {
        position: relative;
    }

    .tier-title {
        .text {
            font-size: 20px !important;
            font-weight: 600 !important;
            text-transform: uppercase;
        }
    }

    .tier-description {
        width: 266px;
        text-align: left;
    }

    .tier-info {
        flex-grow: 0;
        flex-shrink: 0;
        min-width: 100px;

        .tier-bullet-image {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
        }

        .icon {
            width: 29px;
            height: 29px;
        }
    }

    .tx-gray-light {
        color: $color-dryink;
    }

    .tx-gray-dark {
        color: $color-blackhole;
    }

    .watermark {
        max-width: 100px;
        margin: 0 auto;
    }

    &.tier-em-all {
        .summary-bullet-list {
            li.checkmark {
                &::before {
                    background-image: url( '~@/assets/icons/Icon_Checkmark_Active.svg' );
                }
            }
        }

        .summary-divider.hightlight {
            border-color: $color-blue;
        }

        .summary-number {
            color: $color-blue;
        }

        .tier-title {
            .text {
                color: $color-blue;
            }
        }
    }

    &.tier-em-basic {
        .summary-bullet-list {
            li.checkmark {
                &::before {
                    background-image: url( '~@/assets/icons/Icon_Checkmark_Active.svg' );
                }
            }
        }

        .summary-divider.hightlight {
            border-color: $color-blue;
        }

        .summary-number {
            color: $color-blue;
        }
    }
}

</style>
